import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft, Globe } from 'lucide-react';

export default function BharatConnectLayout() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <div className="font-sans">
      {/* Sidebar */}
      <aside className="fixed left-0 top-0 bottom-0 z-20 w-60 bg-white border-r border-slate-100 flex flex-col shadow-sm">
        {/* Brand — top padding pushes it below the global navbar (~57px) */}
        <div className="mt-[57px] px-4 py-3 border-b border-slate-100">
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 bg-gradient-to-br from-[#1B2A4A] to-[#E8720C] rounded-xl flex items-center justify-center flex-shrink-0 shadow-sm text-white">
              <Globe className="h-4 w-4 text-white" />
            </div>
            <div>
              <p className="text-[8px] font-black uppercase tracking-[0.2em] text-[#E8720C]">NBBL Platform</p>
              <p className="text-[13px] font-black text-slate-800">BharatLinc</p>
            </div>
          </div>
        </div>

        {/* Module nav */}
        <nav className="flex-1 px-2 py-3 overflow-y-auto space-y-0.5">
          <div className="px-3 pt-1 pb-1.5 text-[9px] font-black uppercase tracking-wider text-slate-400">
            1. BOU + Biller (Focus)
          </div>
          <button
            onClick={() => navigate('/product/bharat-connect-bou-dashboard')}
            className={`w-full flex items-center gap-2.5 px-3 py-2 rounded-xl text-left transition-all ${pathname.includes('bou') || pathname === '/product/bharat-connect' || pathname === '/product/bharat-connect-ecosystem'
              ? 'bg-orange-50 text-[#E8720C]'
              : 'text-slate-600 hover:bg-slate-50'
              }`}
          >
            <div className="w-6 h-6 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-lg flex items-center justify-center flex-shrink-0 shadow-sm text-white">
              <Globe className="h-3 w-3" />
            </div>
            <span className="text-xs font-black">BOU Command Hub</span>
          </button>

          <button
            onClick={() => navigate('/product/bharat-connect-biller-lifecycle')}
            className={`w-full flex items-center gap-2.5 px-3 py-2 rounded-xl text-left transition-all ${pathname.includes('biller-lifecycle')
              ? 'bg-blue-50 text-blue-700 font-black'
              : 'text-slate-600 hover:bg-slate-50'
              }`}
          >
            <div className="w-6 h-6 bg-gradient-to-br from-blue-500 to-blue-700 rounded-lg flex items-center justify-center flex-shrink-0 shadow-sm text-white">
              <Globe className="h-3 w-3" />
            </div>
            <span className="text-xs font-black">Biller Lifecycle & Queue</span>
          </button>

          <button
            onClick={() => navigate('/product/bharat-connect-settlement-flow')}
            className={`w-full flex items-center gap-2.5 px-3 py-2 rounded-xl text-left transition-all ${pathname.includes('settlement')
              ? 'bg-emerald-50 text-emerald-700 font-black'
              : 'text-slate-600 hover:bg-slate-50'
              }`}
          >
            <div className="w-6 h-6 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-lg flex items-center justify-center flex-shrink-0 shadow-sm text-white">
              <Globe className="h-3 w-3" />
            </div>
            <span className="text-xs font-black">Settlement & 8 Cycles</span>
          </button>

          <button
            onClick={() => navigate('/product/bharat-connect-rcon')}
            className={`w-full flex items-center gap-2.5 px-3 py-2 rounded-xl text-left transition-all ${pathname.includes('rcon')
              ? 'bg-orange-50 text-orange-700 font-black'
              : 'text-slate-600 hover:bg-slate-50'
              }`}
          >
            <div className="w-6 h-6 bg-gradient-to-br from-orange-500 to-amber-600 rounded-lg flex items-center justify-center flex-shrink-0 shadow-sm text-white">
              <Globe className="h-3 w-3" />
            </div>
            <span className="text-xs font-black">RCON 3-Way Match</span>
          </button>

          <button
            onClick={() => navigate('/product/bharat-connect-biller-portal')}
            className={`w-full flex items-center gap-2.5 px-3 py-2 rounded-xl text-left transition-all ${pathname.includes('biller-portal')
              ? 'bg-rose-50 text-rose-700 font-black'
              : 'text-slate-600 hover:bg-slate-50'
              }`}
          >
            <div className="w-6 h-6 bg-gradient-to-br from-rose-500 to-red-600 rounded-lg flex items-center justify-center flex-shrink-0 shadow-sm text-white">
              <Globe className="h-3 w-3" />
            </div>
            <span className="text-xs font-black">Biller Tenant Portal (MTD)</span>
          </button>

          <div className="px-3 pt-3 pb-1 text-[9px] font-black uppercase tracking-wider text-slate-400">
            2. COU + AI
          </div>
          <button
            onClick={() => navigate('/product/bharat-connect-ai-lifecycle')}
            className={`w-full flex items-center gap-2.5 px-3 py-2 rounded-xl text-left transition-all ${pathname.includes('ai-lifecycle')
              ? 'bg-purple-50 text-purple-700 font-black'
              : 'text-slate-600 hover:bg-slate-50'
              }`}
          >
            <div className="w-6 h-6 bg-gradient-to-br from-purple-500 to-purple-700 rounded-lg flex items-center justify-center flex-shrink-0 shadow-sm text-white">
              <Globe className="h-3 w-3" />
            </div>
            <span className="text-xs font-black">AI Agent Lifecycle</span>
          </button>

          <div className="px-3 pt-3 pb-1 text-[9px] font-black uppercase tracking-wider text-slate-400">
            Architecture
          </div>
          <button
            onClick={() => navigate('/product/bharat-connect-architecture')}
            className={`w-full flex items-center gap-2.5 px-3 py-2 rounded-xl text-left transition-all ${pathname.includes('architecture')
              ? 'bg-slate-100 text-slate-900 font-black'
              : 'text-slate-600 hover:bg-slate-50'
              }`}
          >
            <div className="w-6 h-6 bg-gradient-to-br from-slate-600 to-slate-800 rounded-lg flex items-center justify-center flex-shrink-0 shadow-sm text-white">
              <Globe className="h-3 w-3" />
            </div>
            <span className="text-xs font-black">Technical Specs & ERD</span>
          </button>
        </nav>

        {/* Footer */}
        <div className="px-2 py-3 border-t border-slate-100">
          <button
            onClick={() => navigate('/product/bharat-connect-ecosystem')}
            className="w-full flex items-center gap-2.5 px-3 py-2 rounded-xl text-slate-500 hover:bg-orange-50 hover:text-[#E8720C] transition-all"
          >
            <ArrowLeft className="h-4 w-4 flex-shrink-0" />
            <span className="text-xs font-black">BharatLinc Command Hub</span>
          </button>
        </div>
      </aside>

      {/* Page content shifted right by sidebar width */}
      <div className="ml-60">
        <Outlet />
      </div>
    </div>
  );
}
